// extracted by mini-css-extract-plugin
export default {"container":"BlogList_container__MDWjg","blogsInfo":"BlogList_blogsInfo__IkKCa"};